import * as React from 'react';
import * as Glob from '../../Globale';
import * as Dati from '../../Dati';
import * as Data from '../../Data';
import * as DatiFide from '../../DatiFide';
import { NavLink } from 'react-router-dom';
import { Bottone, Paginatore, BaseComponent, Tipo, Trad, ChiamaAPI, CampoData, InputJSON, BottoneAPI, CampoTabellaJSON, GraficoTorta, GraficoBarreOrizzontale } from '../../components/';


interface IFattureDatiEconomiciState {
    ID_FatturaDatiEconomici: number;
    ID_TipoFornitore: string;
    Identificativo: string;
    DataRiferimentoDocumento: Data.CData;
    DatiFatturaJSON: Glob.DatiJSON;
    Creato: Data.CData;
}

export class FattureDatiEconomici extends BaseComponent<Glob.IRouteGlobaleProps, IFattureDatiEconomiciState> {

    private _ID_File: number = 0;
    private _MatchJSON: Glob.DatiJSON = "[]";
    constructor(props: any) {
        super(props);
        this.state = {
            ID_FatturaDatiEconomici: 0, ID_TipoFornitore: "", Identificativo: "", DataRiferimentoDocumento: new Data.CData(), DatiFatturaJSON: "{}", Creato: new Data.CData()
        };
        this.OnChange = this.OnChange.bind(this);
        this.OnErrore = this.OnErrore.bind(this);

        //(this.props.match.params as any).ID_Anag
    }

    private OnInvioSalvaFile(sender: BottoneAPI): any {
        let Ingr: Dati.CIngrAPI<Dati.CFatturaDatiEconomici> = new Dati.CIngrAPI<Dati.CFatturaDatiEconomici>();
        Ingr.Dato.Creato = this.state.Creato.Data;
        Ingr.Dato.DataRiferimentoDocumento = this.state.DataRiferimentoDocumento.Data;
        Ingr.Dato.DatiFatturaJSON = this.state.DatiFatturaJSON;
        Ingr.Dato.Identificativo = this.state.Identificativo;
        Ingr.Dato.ID_FatturaDatiEconomici = this.state.ID_FatturaDatiEconomici;
        Ingr.Dato.ID_TipoFornitore = this.state.ID_TipoFornitore;
        return Ingr;
    }

    private OnClickSalvaFile(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("FILE ERRORE"), dati.ErrTesto);
        }
        else {
            this.props.history.replace("/file/" + dati.ID_Chiave + "/" + this._ID_File);
        }
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIDato<Dati.CFatturaDatiEconomiciMatch>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this._ID_File = dati.ID_Chiave;
            this._MatchJSON = dati.Dato.MatchJSON;
            this.setState({ ID_FatturaDatiEconomici: dati.Dato.ID_FatturaDatiEconomici, ID_TipoFornitore: dati.Dato.ID_TipoFornitore, Identificativo: dati.Dato.Identificativo, DataRiferimentoDocumento: new Data.CData(dati.Dato.DataRiferimentoDocumento), DatiFatturaJSON: dati.Dato.DatiFatturaJSON, Creato: new Data.CData(dati.Dato.Creato) });
        }
        return true;
    }

    public render() {

        let NumeroMatch: number = 0;
        let NumeroDisMatch: number = 0;
        if (this._MatchJSON != undefined && this._MatchJSON != null) {
            let DatiMatch: any[] = JSON.parse(this._MatchJSON);
            for (let i: number = 0; i < DatiMatch.length; i++) {
                if (DatiMatch[i].Controllo == "MATCH")
                    NumeroMatch++;
                else
                    NumeroDisMatch++;
            }
        }

        let datiGrafico: number[] = [];
        let datiGraficoPercentuale: number[] = [];
        let etichette: string[] = [];
        let etichettePercentuale: string[] = [];
        let coloriDiSfondo: string[] = [];
        let coloriDiSfondoSuSelezione: string[] = [];

        datiGrafico.push(NumeroMatch);
        datiGraficoPercentuale.push(100 / (NumeroMatch + NumeroDisMatch) * NumeroMatch);
        etichette.push("MATCH");
        etichettePercentuale.push("% MATCH");
        coloriDiSfondo.push("#34BFA3");

        datiGrafico.push(NumeroDisMatch);
        datiGraficoPercentuale.push(100 / (NumeroMatch + NumeroDisMatch) * NumeroDisMatch);
        etichette.push("DISMATCH");
        etichettePercentuale.push("% DISMATCH");
        coloriDiSfondo.push("#F60628");



        return <div>
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-money-check-alt"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">
                                {Trad.Trad("FattureDatiEconomici")}
                            </h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">

                            </div>
                        </ul>
                    </div>
                </div>
                <form className="kt-form login-form kt-form login-form--label-align-left- kt-form login-form--state-" id="kt_form" noValidate>
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row">
                            <div className={Glob.DimensioneCSS(1)}>
                                <label>ID</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input type="text" className="form-control kt-input" value={this.state.ID_FatturaDatiEconomici} name="ID_FatturaDatiEconomici" onChange={(e) => { this.OnChange(e) }} />
                                </div>
                            </div>
                            <div className={Glob.DimensioneCSS(6)}>
                                <label>{Trad.Trad("Identificativo")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input type="text" className="form-control kt-input" value={this.state.Identificativo} name="Identificativo" onChange={(e) => { this.OnChange(e) }} />
                                </div>
                            </div>
                            <div className={Glob.DimensioneCSS(2)}>
                                <label>{Trad.Trad("DataRiferimento")}</label>
                                <div className="form-control">
                                    <CampoData ValoreInArrivo={this.state.ID_FatturaDatiEconomici > 0} Name="DataRiferimentoDocumento" Id="DataRiferimentoDocumento" Valore={this.state.DataRiferimentoDocumento.Data} OnChange={this.OnChange} />
                                </div>
                            </div>
                            <div className={Glob.DimensioneCSS(2)}>
                                <label>{Trad.Trad("DataRiferimento")}</label>
                                <Tipo Campo="ID_TipoFornitore" ID_ChiaveString={this.state.ID_TipoFornitore} OnAggiorna={this.OnChange} URL="/api/Tipi/ListaTipi?ID_TipoContesto=ForitoriDatiEconomici" TradValori={false} />
                            </div>
                            <div className={Glob.DimensioneCSS(1)}>
                                <label>File</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <BottoneAPI Default={false} Testo={""} Icona="flaticon-open-box" URL="/api/FatturaDatiEconomici/" Metodo="POST" OnInvio={(s) => this.OnInvioSalvaFile(s)} OnClick={(s, d) => this.OnClickSalvaFile(s, d)} OnErrore={(s, e) => this.OnErrore(s, e)} Visibile={this._Scrittura} />
                                </div>
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <InputJSON CSS={Glob.DimensioneCSS(12)} Name="DatiFatturaJSON" Id="DatiFatturaJSON" Valore={this.state.DatiFatturaJSON} OnChange={this.OnChange} Etichetta={Trad.Trad("DatiFattura")} />
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <div className={Glob.DimensioneCSS(6)}>
                                <GraficoBarreOrizzontale Dati={datiGrafico} Etichette={etichette} Titolo={Trad.Trad("Valori netti esito")} Larghezza={100} Altezza={100} ColoriDiSfondo={coloriDiSfondo} ColoriDiSfondoSuSelezione={["#B0B0B0", "#B0B0B0", "#B0B0B0"]} ColoreBordo="#B0B0B0" ColoreBordoSuSelezione="#C0C0C0" SpessoreBordo={2} />
                            </div>
                            <div className={Glob.DimensioneCSS(6)}>
                                <GraficoTorta Dati={datiGraficoPercentuale} Etichette={etichettePercentuale} Titolo={Trad.Trad("Valori percentuali esito")} Larghezza={100} Altezza={100} ColoriDiSfondo={coloriDiSfondo} ColoriDiSfondoSuSelezione={["#B0B0B0", "#B0B0B0", "#B0B0B0"]} />
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <CampoTabellaJSON Value={this._MatchJSON} Id="MatchJSON" Name="MatchJSON" OnChange={() => { }} />
                        </div>
                    </div>
                    <ChiamaAPI Aggiornare={1} URL={"/api/FatturaDatiEconomici?ID_FatturaDatiEconomici=" + (this.props.match.params as any).ID_FatturaDatiEconomici} Metodo="GET" OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
                </form>
            </div>
        </div >;
    }
}


// WEBPACK FOOTER //
// ./src/form/Contabilita/FattureDatiEconomici.tsx